import { colors } from "laravel-mix/src/Log";

export default function Menu(){
    /// MENU INSIDER
    const links = document.querySelectorAll('.primary-link')
    const dataTargetList = document.querySelectorAll('[data-target]')

    links.forEach((link, index) =>{
        link.addEventListener('mouseover', () =>{
             // Remove "ativo" class from all links
            links.forEach((link) => link.classList.remove("ativo"));
            // Add "ativo" class to the hovered link
            link.classList.add("ativo");
            const targetValue = "data-target-2";
        })
    })


    //MENU LINK
    const linkMenu = document.querySelectorAll('.link')
    const menuInsiderItemns = document.querySelectorAll('.menu-insider')

    linkMenu.forEach((link) => {
        $(link).on('mouseenter', () => {
            gsap.set(link,{
                color: '#EAB64E',
                textDecoration: 'underline',
            });
            gsap.to(menuInsiderItemns, {
                duration: 0.3,
                scaleY: 0,
                x: -84,
                ease: 'power2.inOut',
            });

            let menuInsider = link.querySelector('.menu-insider');
            gsap.to(menuInsider, {
                duration: 0.3,
                scaleY: 1,
                x: -84,
                ease: 'power2.inOut',
            });
        });
        $(link).on('mouseleave', () => {
            gsap.set(link,{
                color: '#002C55',
                textDecoration: 'none',
            });
        })
        menuInsiderItemns.forEach((menuInsiderItemn) => {
            menuInsiderItemn.addEventListener('mouseleave', () => {
                gsap.set(linkMenu,{
                    color: '#002C55',
                    TextDecoration: 'none',
                });
                gsap.to(menuInsiderItemn, {
                    duration: 0.3,
                    scaleY: 0,
                    ease: 'power2.inOut',
                });
            });
        });
    });


    // SEARCH BAR



    document.addEventListener('DOMContentLoaded', function () {
        const searchIcon = document.querySelector('.search img'); // Select the search icon image
        const searchBox = document.querySelector('.search-inside'); // Select the search box container
        const searchOnly = document.querySelector('.search');
        let isSearchBoxOpen = false; // Track the state of the search box

        // Function to open the search box with GSAP animation
        function openSearchBox() {
          gsap.to(searchBox, {
            duration: 0.3,
            scaleY: 1,
            ease: 'power2.inOut',
            onStart: function () {
              searchBox.style.display = 'flex'; // Make the box visible before the animation
              searchOnly.classList.add('active');
            }
          });
        }


        const closeIconMobile = document.querySelector('.close-inside-menu-mobile');

        closeIconMobile.addEventListener('click', function () {
          closeSearchBox();
        });

        // Function to close the search box with GSAP animation
        function closeSearchBox() {
          gsap.to(searchBox, {
            duration: 0.3,
            scaleY: 0,
            ease: 'power2.inOut',
            onComplete: function () {
              searchBox.style.display = 'none'; // Hide the box after the animation completes
              searchOnly.classList.remove('active');
            }
          });
        }



        // Toggle the search box on click of the search icon
        searchIcon.addEventListener('click', function (event) {
          event.stopPropagation(); // Stop the click event from propagating
          if (isSearchBoxOpen) {
            closeSearchBox();
          } else {
            openSearchBox();
          }
          isSearchBoxOpen = !isSearchBoxOpen;
        });

        // Prevent closing when clicking inside the search box
        searchBox.addEventListener('click', function (event) {
          event.stopPropagation(); // Stop the event from propagating, preventing closure
        });

        // Close search box if the user clicks outside
        document.addEventListener('click', function () {
          if (isSearchBoxOpen) {
            closeSearchBox();
            isSearchBoxOpen = false;
          }
        });
      });



    //Profile BAR
    document.addEventListener('DOMContentLoaded', function () {
        const userIcon = document.querySelector('.user img'); // Select the user icon image
        const userBox = document.querySelector('.config'); // Select the search box container
        let isuserBoxOpen = false; // Track the state of the search box

        // Function to open the search box with GSAP animation
        function openuserBox() {
          gsap.to(userBox, {
            duration: 0.3,
            scaleY: 1,
            ease: 'power2.inOut',
            onStart: function () {
              userBox.style.display = 'flex'; // Make the box visible before the animation
            }
          });
        }

        // Function to close the search box with GSAP animation
        function closeuserBox() {
          gsap.to(userBox, {
            duration: 0.3,
            scaleY: 0,
            ease: 'power2.inOut',
            onComplete: function () {
              userBox.style.display = 'none'; // Hide the box after the animation completes
            }
          });
        }

        const closeuseBoxMobile = document.querySelector('.close-config');

        closeuseBoxMobile.addEventListener('click', function () {
          closeuserBox();
        });

        // Toggle the search box on click of the search icon
        userIcon.addEventListener('click', function (event) {
          event.stopPropagation(); // Stop the click event from propagating
          if (isuserBoxOpen) {
            closeuserBox();
          } else {
            openuserBox();
          }
          isuserBoxOpen = !isuserBoxOpen;
        });

        // Prevent closing when clicking inside the search box
        userBox.addEventListener('click', function (event) {
          event.stopPropagation(); // Stop the event from propagating, preventing closure
        });

        // Close search box if the user clicks outside
        document.addEventListener('click', function () {
          if (isuserBoxOpen) {
            closeuserBox();
            isuserBoxOpen = false;
          }
        });
      });


      $(document).ready(function(){
        $("#hamburger-1").click(function(){
          $(this).toggleClass("is-active");
            $(".menu-links").addClass("active");
        });
      });

      $(document).ready(function(){
        $("#hamburger-2").click(function(){
            $(".menu-links").removeClass("active");
            $("#hamburger-1").removeClass("is-active");
        });
      });

      const lateralLinks = document.querySelectorAll('.menu-links ul li');

      // Add event listeners to each link
      lateralLinks.forEach(link => {
        link.addEventListener('click', () => {

          // Find the related '.lateral-links-inside' element within the clicked link
          const relatedMenu = link.querySelector('.lateral-links-inside');

          // Check if the clicked link is already active (open)
          const isActive = link.classList.contains('active');

          // Close all menus except the current one
          lateralLinks.forEach(otherLink => {
            const otherMenu = otherLink.querySelector('.lateral-links-inside');
            if (otherMenu && otherLink !== link) {
              otherLink.classList.remove('active');
              closeMenu(otherMenu); // Close other menus
            }
          });

          // Toggle the clicked menu
          if (isActive) {
            // If it's already active, close it
            link.classList.remove('active');
            closeMenu(relatedMenu);
          } else {
            // If it's not active, activate and expand it
            link.classList.add('active');
            expandMenu(relatedMenu);
          }
        });
      });

      function expandMenu(menu) {
        if (menu) {  // Ensure the menu exists
          gsap.timeline()
            .to(menu, {
              duration: .6,
              height: "auto",
              paddingTop: 15,
              ease: "power4.out"
            })
            .to(
              menu.querySelectorAll('a'),  // Only target anchors within the clicked menu
              {
                duration: 0.3,
                opacity: 1,
                ease: "power4.out",
                stagger: 0.2
              },
              0.3
            );
        }
      }

      function closeMenu(menu) {
        if (menu) {  // Ensure the menu exists
          gsap.timeline()
            .to(menu, {
              delay: 0.1,
              duration: 1,
              ease: "power4.out",
              paddingTop: 0,
              height: 0
            })
            .to(
              menu.querySelectorAll('a'),  // Only target anchors within the clicked menu
              {
                duration: 0.6,
                opacity: 0,
                ease: "power4.out",
                stagger: 0.2
              },
              0
            );
        }
      }

}









